// File generated from our OpenAPI spec
import { StripeResource } from '../StripeResource.js';
const stripeMethod = StripeResource.method;
export const Balance = StripeResource.extend({
    retrieve: stripeMethod({ method: 'GET', fullPath: '/v1/balance' }),
});
